import React, { useContext, useState } from 'react';
import { useAuth } from '@frontegg/react';
import countries from 'i18n-iso-countries';
import AddButton from '../AddButton';
import { ElementContext } from '../ElementContext';
import RemoveButton from '../RemoveButton';
import SelectListButton from '../SelectListButton';
import ContactInfo from '../ContactInfo';
import { useTranslation } from 'react-i18next';
import { useEffect } from 'react';
import { sendTemplateMessage } from '../../helpers/whatsapp-api';
import WhatsappAPISelector from './WhatsappAPISelector';
import Swal from 'sweetalert2';
import SelectListModal from '../modals/SelectListModal';
import 'animate.css';
import '../../styles/sidebar.css';

countries.registerLocale(require("i18n-iso-countries/langs/en.json"));
countries.registerLocale(require("i18n-iso-countries/langs/es.json"));

String.prototype.replaceAll = function(strReplace, strWith) {
    var esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    var reg = new RegExp(esc, 'ig');
    return this.replace(reg, strWith);
};

const WhatsappAPIMessages = () => {
    
    const { user } = useAuth();
    const { userInformation, inputList, setInputList, toggleSidebar, infoToShow, whatsappTemplates, userConfiguration, selectedWACredentials, approvedTemplates, wAPIUserInformation } = useContext(ElementContext);

    const { t, i18n } = useTranslation();
    const [loading, setLoading] = useState(false);
    const [templateMessage, setTemplateMessage] = useState({ 'header': '', 'body': '', 'footer': '' });
    const [templateName, setTemplateName] = useState('');
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [messageFailed, setMessageFailed] = useState({ ok: false, msg: '' });
    
    // 🆕 ESTADO PARA EL MAPEO DE VARIABLES (qué campo usar para cada variable)
    const [variableMapping, setVariableMapping] = useState({});

    useEffect(() => {
        setInputList([
          { numero: userInformation.countryCode }
        ])
    }, [])
    
    const handleInputChange = (e, index) => {
      const { name, value } = e.target;
      const list = [...inputList];
      list[index][name] = value;
      setInputList(list)
    }

    const handleRemoveInput = (index) => {
        if(inputList.length >= 2){
            const list = [...inputList];
            list.splice(index, 1);
            setInputList(list);
        } else {
            setInputList([
                {numero: ''}
              ])
        }
    }

    // 🔧 MANEJAR CAMBIO EN EL SELECT DE VARIABLES
    const handleVariableChange = (varKey, fieldValue) => {
        console.log(`Variable ${varKey} mapeada a: ${fieldValue}`);
        setVariableMapping(prev => ({
            ...prev,
            [varKey]: fieldValue
        }));
    }

    const handleSelectTemplate = async() => {
        try {
            const template = document.querySelector('#tempSelect').selectedOptions[0].value;
            
            if (!template || template === 'default') {
                console.log('No se seleccionó plantilla válida');
                return;
            }

            const templateSelected = whatsappTemplates.find(temp => temp.name === template);
            
            if (!templateSelected) {
                console.error('❌ Plantilla no encontrada');
                Swal.fire('Error', 'No se encontró la plantilla seleccionada', 'error');
                return;
            }

            console.log('📋 Plantilla seleccionada:', templateSelected);

            if (!templateSelected.components || !Array.isArray(templateSelected.components)) {
                console.error('❌ La plantilla no tiene componentes válidos');
                Swal.fire('Error', 'La plantilla no tiene un formato válido', 'error');
                return;
            }

            const headerComponent = templateSelected.components.find(comp => comp.type === 'HEADER');
            const bodyComponent = templateSelected.components.find(comp => comp.type === 'BODY');
            const footerComponent = templateSelected.components.find(comp => comp.type === 'FOOTER');

            const templateHeader = headerComponent?.text || '';
            const templateBody = bodyComponent?.text || '';
            const templateFooter = footerComponent?.text || '';

            if (!templateBody) {
                console.error('❌ La plantilla no tiene cuerpo');
                Swal.fire('Error', 'La plantilla no tiene un cuerpo de mensaje', 'error');
                return;
            }

            // 🔍 EXTRAER VARIABLES DEL BODY
            const bodyVars = (templateBody.match(/\{\{(\d+)\}\}/g) || []).map(v => parseInt(v.replace(/[{}]/g, '')));
            
            console.log(`📊 Variables detectadas en body: ${bodyVars.length}`, bodyVars);

            // 🆕 CARGAR EL MAPEO GUARDADO SI EXISTE (de la plantilla)
            if (templateSelected.variableMapping) {
                setVariableMapping(templateSelected.variableMapping);
            } else {
                // Inicializar mapeo vacío
                const initialMapping = {};
                bodyVars.forEach(varNum => {
                    initialMapping[`body_${varNum}`] = '';
                });
                setVariableMapping(initialMapping);
            }

            setTemplateName(template);
            setSelectedTemplate(templateSelected);
            setTemplateMessage({
                'header': templateHeader,
                'body': templateBody,
                'footer': templateFooter
            });

        } catch (error) {
            console.error('❌ Error al seleccionar plantilla:', error);
            Swal.fire('Error', 'Error al cargar la plantilla: ' + error.message, 'error');
        }
    }

    // 🔧 REEMPLAZAR VARIABLES CON VALORES REALES DEL CONTACTO
    const replaceVariablesInText = (text, contact, mapping) => {
        if (!text || !mapping) return text;
        
        let result = text;
        
        // Por cada variable en el mapeo
        Object.keys(mapping).forEach(varKey => {
            const fieldName = mapping[varKey]; // ej: "$NOMBRE$"
            const varNumber = varKey.split('_')[1]; // ej: "body_1" -> "1"
            const placeholder = `{{${varNumber}}}`; // ej: "{{1}}"
            
            // Obtener el valor real del contacto según el campo mapeado
            let realValue = '';
            
            if (fieldName === '$NOMBRE$') realValue = contact.nombre || '';
            else if (fieldName === '$APELLIDO$') realValue = contact.apellido || '';
            else if (fieldName === '$NUMERO$') realValue = contact.numero || '';
            else if (fieldName === '$CARGO$') realValue = contact.cargo || '';
            else if (fieldName === '$PAIS$') realValue = contact.pais || '';
            else if (fieldName === '$OBSERVACIONES$') realValue = contact.observaciones || '';
            else if (fieldName === '$EMPRESA$') realValue = contact.empresa || '';
            else if (fieldName === '$MONTO$') realValue = contact.monto || '';
            else if (fieldName === '$FECHAVENCIMIENTO$') realValue = contact.fechavencimiento || '';
            else if (fieldName === '$NUMEROFACTURA$') realValue = contact.numerofactura || '';
            else if (fieldName === '$FECHACUMPLEAÑOS$') realValue = contact.fechacumpleaños || '';
            
            // Reemplazar en el texto
            result = result.replace(placeholder, realValue);
        });
        
        return result;
    }

    const handleSubmitTemplateMessage = async(e) => {
        e.preventDefault();
        setLoading(true);
        setMessageFailed({ ok: false, msg: '' });
        
        // Validar que se hayan mapeado todas las variables
        const bodyVars = (templateMessage.body.match(/\{\{(\d+)\}\}/g) || []);
        if (bodyVars.length > 0) {
            const allMapped = bodyVars.every(varPlaceholder => {
                const varNum = varPlaceholder.replace(/[{}]/g, '');
                const mapping = variableMapping[`body_${varNum}`];
                return mapping && mapping !== '';
            });
            
            if (!allMapped) {
                Swal.fire('Error', 'Debes seleccionar un campo para todas las variables', 'warning');
                setLoading(false);
                return;
            }
        }
        
        const usersList = infoToShow.length > 0
            ? await infoToShow.map( user => user.numero )
            : await inputList.map( user => user.numero );

        const allWACredentials = await userConfiguration.whatsappAPIcredentials;
        const WACredentials = await allWACredentials.filter( cred => cred.phoneNumberId === selectedWACredentials )[0];

        const numberOrigin = wAPIUserInformation.map( waInfo => waInfo.id === selectedWACredentials ? waInfo.display_phone_number : null ).filter( num => num !== null )[0];
        console.log('NUMBER ORIGIN', numberOrigin);

        let deliverySuccess = 0;
        let deliveryFailed = 0;
        
        for(let i=0; i<usersList.length; i++){
            const phone = usersList[i];

            // 🔧 OBTENER INFORMACIÓN DEL CONTACTO
            const contact = infoToShow.length > 0 ? infoToShow[i] : { numero: phone };
            
            const contactInfo = infoToShow.length > 0 ? {
                nombre: infoToShow[i].nombre || null,
                apellido: infoToShow[i].apellido || null,
                empresa: infoToShow[i].empresa || null,
                cargo: infoToShow[i].cargo || null,
                pais: infoToShow[i].pais || null,
                observaciones: infoToShow[i].observaciones || null,
                monto: infoToShow[i].customfields?.monto || null,
                fechavencimiento: infoToShow[i].customfields?.fechavencimiento || null,
                numerofactura: infoToShow[i].customfields?.numerofactura || null,
                fechacumpleaños: infoToShow[i].customfields?.fechacumpleaños || null,
                email: user.email,
            } : { email: user.email };

            // 🆕 REEMPLAZAR VARIABLES EN EL TEXTO DEL BODY
            const bodyWithValues = replaceVariablesInText(templateMessage.body, contact, variableMapping);
            
            console.log('📤 Enviando mensaje personalizado:', bodyWithValues);
            
            // 🔧 CONSTRUIR TEMPLATE CON COMPONENTES
            const componentsToSend = [];

            const bodyVarNumbers = (templateMessage.body.match(/\{\{(\d+)\}\}/g) || [])
                .map(v => parseInt(v.replace(/[{}]/g, '')));

            if (bodyVarNumbers.length > 0) {
                const bodyParams = [];
                
                bodyVarNumbers.forEach(varNum => {
                    const varKey = `body_${varNum}`;
                    const fieldName = variableMapping[varKey];
                    let realValue = '';
                    
                    // 🔥 USA contactInfo EN LUGAR DE contact
                    if (fieldName === '$NOMBRE$') realValue = contactInfo.nombre || '';
                    else if (fieldName === '$APELLIDO$') realValue = contactInfo.apellido || '';
                    else if (fieldName === '$NUMERO$') realValue = phone || '';
                    else if (fieldName === '$CARGO$') realValue = contactInfo.cargo || '';
                    else if (fieldName === '$PAIS$') realValue = contactInfo.pais || '';
                    else if (fieldName === '$OBSERVACIONES$') realValue = contactInfo.observaciones || '';
                    else if (fieldName === '$EMPRESA$') realValue = contactInfo.empresa || '';
                    else if (fieldName === '$MONTO$') realValue = contactInfo.monto || 'N/A'; // 🔥 CAMBIO AQUÍ
                    else if (fieldName === '$FECHAVENCIMIENTO$') realValue = contactInfo.fechavencimiento || 'Por definir'; // 🔥
                    else if (fieldName === '$NUMEROFACTURA$') realValue = contactInfo.numerofactura || 'Pendiente'; // 🔥
                    else if (fieldName === '$FECHACUMPLEAÑOS$') realValue = contactInfo.fechacumpleaños || 'No especificado'; // 🔥
                    
                    console.log(`📝 Variable ${varNum} (${fieldName}) = "${realValue}"`); // 🔍 DEBUG
                    
                    bodyParams.push({
                        type: 'text',
                        text: realValue
                    });
                });
                
                componentsToSend.push({
                    type: 'body',
                    parameters: bodyParams
                });
            }
            
            
            const templateToSend = {
                ...selectedTemplate,
                components: componentsToSend.length > 0 ? componentsToSend : undefined
            };


            console.log('📤 Template final a enviar:', JSON.stringify(templateToSend, null, 2)); // 🔍 DEBUG

            const envioMensaje = await sendTemplateMessage(WACredentials, templateToSend, phone, contactInfo, numberOrigin);
            
            if(envioMensaje.ok && envioMensaje.json && envioMensaje.json.messages) {
                deliverySuccess++;
            } else {
                deliveryFailed++;
                const errorMsg = envioMensaje.msg || 'Error desconocido';
                setMessageFailed({ 
                    ok: true, 
                    msg: `${t('failedText1')} ${phone}, ${t('failedText2')}: ${errorMsg}` 
                });
            }
        }

        Swal.fire( 
            t('completed'), 
            `${t('successfulMessages')}: ${deliverySuccess}, ${t('failedMessages')}: ${deliveryFailed}`, 
            'success'
        );
        setLoading(false);
    }

    if(!userConfiguration.whatsappAPIcredentials || userConfiguration.whatsappAPIcredentials.length < 1){
        return <div className='home '>
                    <h1 className='text-center text-mediumblue mt-10'>{t('youDontHaveCreentials')}</h1>
               </div>
    }

    // 🔍 EXTRAER VARIABLES DEL BODY ACTUAL
    const bodyVars = (templateMessage.body.match(/\{\{(\d+)\}\}/g) || [])
        .map(v => parseInt(v.replace(/[{}]/g, '')));

    return (
        <div className="home animate__animated animate__fadeIn">
            <div className="d-flex align-items-center justify-content-between">
                <div className={ toggleSidebar ? 'titles-margin-close' : 'titles-margin-open' }>
                    <div className="text">
                        {t('sendWApiMessages')}
                    </div>
                    <p className='subtitle mb-0'>
                        {t('sendWApiTemplates')}
                    </p>
                </div>
            </div>

            <div className="container">
                <div className="row d-flex justify-content-between my-4">
                    <div className="col-6 btn-group btn-group-width">
                        <AddButton/>
                        <SelectListButton/>
                        <RemoveButton/>
                    </div>
                    
                    <div className="col-6">
                        <WhatsappAPISelector handleSelectTemplate={handleSelectTemplate} approvedTemplates={approvedTemplates}/>
                    </div>
                </div>

                <form id="whatsappForm" encType='multipart/form-data' onSubmit={ handleSubmitTemplateMessage }>
                    <div className="row d-flex justify-content-between">
                        <div id="formDiv" className="col-6 mb-3">
                            <label className="form-label text-91">
                                {t('contacts')} - {t('enterPhoneNumber')}
                            </label>
                            {
                                infoToShow.length > 0 ? (
                                    <ContactInfo/>
                                ) : (
                                    inputList.map( (item, index) => {
                                        return (
                                            <div key={index} className="d-flex align-items-center mb-1">
                                                <input
                                                    type="text"
                                                    className="form-control me-2"
                                                    placeholder={t('enterPhoneNumber')}
                                                    name="numero"
                                                    value={item.numero || ''}
                                                    onChange={ e => handleInputChange(e, index) }
                                                />
                                                <i
                                                    className='bx bx-trash icon text-danger me-4 pointer'
                                                    onClick={ () => handleRemoveInput(index) }
                                                ></i>
                                            </div>
                                        )})
                                )
                            }
                        </div>
                        
                        <div className="col-6 mb-3">
                            <div className="d-flex align-items-center justify-content-between">
                                <label htmlFor="wa-text" className="form-label text-91">
                                    {t('message')}
                                    {bodyVars.length > 0 && (
                                        <span className="badge bg-warning text-dark ms-2">
                                            {bodyVars.length} variable{bodyVars.length > 1 ? 's' : ''}
                                        </span>
                                    )}
                                </label>
                            </div>
                            
                            {
                                messageFailed.ok && (
                                    <div className="alert alert-danger" role="alert">
                                        { messageFailed.msg }
                                    </div>
                                )
                            }

                            {/* 🆕 SELECTORES PARA MAPEAR VARIABLES */}
                            {bodyVars.length > 0 && (
                                <div className="mb-3">
                                    <div className="row">
                                        {bodyVars.map((varNum, index) => {
                                            const varKey = `body_${varNum}`;
                                            return (
                                                <div key={varKey} className="col-6">
                                                    <label className="form-label mb-1">
                                                        <small>Variable {varNum}:</small>
                                                    </label>
                                                    <select 
                                                        className="form-select form-select-sm"
                                                        value={variableMapping[varKey] || ''}
                                                        onChange={(e) => handleVariableChange(varKey, e.target.value)}
                                                        required
                                                    >
                                                        <option value="">Selecciona un campo</option>
                                                        <option value="$NOMBRE$">Nombre</option>
                                                        <option value="$APELLIDO$">Apellido</option>
                                                        <option value="$PAIS$">País</option>
                                                        <option value="$NUMERO$">Teléfono</option>
                                                        <option value="$CARGO$">Cargo</option>
                                                        <option value="$OBSERVACIONES$">Observaciones</option>
                                                        <option value="$EMPRESA$">Empresa</option>
                                                        <option value="$MONTO$">Monto</option>
                                                        <option value="$FECHAVENCIMIENTO$">Fecha Vencimiento</option>
                                                        <option value="$NUMEROFACTURA$">Número Factura</option>
                                                        <option value="$FECHACUMPLEAÑOS$">Fecha Cumpleaños</option>
                                                    </select>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}

                            <div className='wa-message-box'>
                                {
                                    templateMessage.body ? (
                                        <>
                                            <h6 className='wa-header'>{ templateMessage.header }</h6>
                                            <p className='wa-body'>{ templateMessage.body }</p>
                                            <span className='wa-footer'>{ templateMessage.footer }</span>
                                        </>
                                    ) : (
                                        <p className='text-91'>
                                            {t('templateNotSelected')}
                                        </p>
                                    )
                                }
                            </div>

                            <div className='btn-group w-100'>
                                <button
                                    id="form-button"
                                    className="btn btn-sm btn-lightblue mt-3 w-25"
                                    type="submit"
                                    disabled={loading}
                                >
                                    {loading ? 'Enviando...' : t('send')}
                                </button>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
            
            <SelectListModal/>
        </div>
    )
};
  
export default WhatsappAPIMessages;